import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import type { IState } from './types/AccessorialChargesSlice.types';

import { initialState } from './utils/initial.state';
import { RootState } from '@/store/store';

export const accessorialChargesSlice = createSlice({
  name: 'AccessorialCharges',
  initialState,
  reducers: {
    setFilters: (state, action: PayloadAction<Partial<IState['filters']>>) => {
      state.filters = { ...state.filters, ...action.payload };
    },
    setAccessorialCharges: (state, action: PayloadAction<IState['accessorialCharges']>) => {
      state.accessorialCharges = action.payload;
    },
  },
});

export const accessorialChargesSelectors = {
  filters: (state: RootState) => state.accessorialCharges.filters,
  accessorialCharges: (state: RootState) => state.accessorialCharges.accessorialCharges,
};

export const accessorialChargesActions = accessorialChargesSlice.actions;
